import { Column } from '@synqo/frontend-component-library';
import { ApiContainer } from '@Model';

export const containerColumns: Column<ApiContainer>[] = [
    { name: 'number', label: 'Nummer' },
    { name: 'position.display_string', label: 'Aktuelle Position' },
    { name: 'type.display_string', label: 'Typ' },
];
